import * as TYPES from '../types'
import api from '../../api'

const state = {
  admin: {
    token: null
  },
  search: {
    items: []
  },
  list: {
    pageIndex: 1,
    pageSize: 10,
    totalCount: 20,
    totalPage: 0,
    items: []
  },
  view: {
    phone: '',
    profile: {
      name: '',
      address: '',
      phone: '',
      sex: '',
      vipID: '',
      balance: ''
    }
  },
  accountRecords: [],
  editing: {
    profile: {
      name: '',
      phone: '',
      address: '',
      sex: ''
    }
  },
  recharge: {
    fee: {
      fromCash: 0,
      fromAlipay: 0,
      fromWechat: 0,
      giftAccount: 0
    },
    feeView: {
      user: {
        profile: {}
      }
    }
  }
}

const mutations = {
  [TYPES.ON_GET_USER_SEARCH](state, data) {
    state.list = data
  },
  [TYPES.ON_GET_ALL_USERS](state, data) {
    state.list = data
  },
  [TYPES.ON_USER_VIEW](state, user) {
    state.view = user
  },
  [TYPES.ON_GET_ACCOUNT_RECORD](state, data) {
    state.recharge.feeView = data
  },
  [TYPES.ON_GET_ACCOUNT_RECORD_LIST](state, data) {
    state.accountRecords = data
  },
  [TYPES.ON_LOGIN](state, data) {
    state.admin = data
    localStorage.setItem('token', data)
  }
}

const actions = {
  [TYPES.DO_CREATE_VIP]({ commit }, vip) {
    return new Promise(function (resolve, reject) {
      api
        .DO_CREATE_VIP(vip)
        .then(res => {
          if (res.data.ok) {
            resolve(res)
          } else {
            reject(res)
          }
        })
        .catch(res => {
          reject(res)
        })
    })
  },
  [TYPES.DO_GET_ALL_USERS]({ commit }) {
    return new Promise(function (resolve, reject) {
      api
        .DO_GET_ALL_USERS()
        .then(res => {
          if (res.data.ok) {
            commit(TYPES.ON_GET_ALL_USERS, res.data.data)
            resolve(res)
          } else {
            reject(res)
          }
        })
        .catch(res => {
          reject(res)
        })
    })
  },
  [TYPES.DO_GET_USER_LIST]({ commit, state }) {
    return new Promise(function (resolve, reject) {
      api
        .DO_GET_USER_LIST(state.users.list.pageIndex)
        .then(res => {
          if (res.data.ok) {
            commit(TYPES.ON_GET_USER_LIST, res.data.data)
            resolve(res)
          } else {
            reject(res)
          }
        })
        .catch(res => {
          reject(res)
        })
    })
  },
  [TYPES.ON_USER_VIEW]({ commit }, user) {
    commit(TYPES.ON_USER_VIEW, user)
  },
  [TYPES.DO_USER_VIEW]({ commit }, phone) {
    return new Promise(function (resolve, reject) {
      api
        .DO_USER_VIEW(phone)
        .then(res => {
          if (res.data.ok) {
            commit(TYPES.ON_USER_VIEW, res.data.data)
            resolve(res)
          } else {
            reject(res)
          }
        })
        .catch(res => {
          reject(res)
        })
    })
  },
  [TYPES.DO_UPDATE_USER_PROFILE]({ commit }, userInfo) {
    return new Promise(function (resolve, reject) {
      api
        .DO_UPDATE_USER_PROFILE(userInfo)
        .then(res => {
          if (res.data.ok) {
            commit(TYPES.ON_USER_VIEW, res.data.data)
            resolve(res)
          } else {
            reject(res)
          }
        })
        .catch(res => {
          reject(res)
        })
    })
  },
  [TYPES.DO_GET_USER_SEARCH]({ commit }, key) {
    return new Promise(function (resolve, reject) {
      api
        .DO_SEARCH(key)
        .then(res => {
          if (res.data.ok) {
            commit(TYPES.ON_GET_USER_SEARCH, res.data.data)
            resolve(res)
          } else {
            reject(res)
          }
        })
        .catch(res => {
          reject(res)
        })
    })
  },
  [TYPES.DO_RECHARGE]({ commit }, { userID, fee }) {
    console.log(userID, fee)
    return new Promise(function (resolve, reject) {
      api.DO_RECHARGE(userID, fee)
        .then(res => {
          if (res.data.ok) {
            resolve(res)
          } else {
            reject(res)
          }
        })
        .catch(res => {
          reject(res)
        })
    })
  },
  [TYPES.DO_GET_ACCOUNT_RECORD]({ commit }, idView) {
    return new Promise(function (resolve, reject) {
      api.DO_GET_ACCOUNT_RECORD(idView)
        .then(res => {
          if (res.data.ok) {
            commit(TYPES.ON_GET_ACCOUNT_RECORD, res.data.data)
            resolve(res)
          } else {
            reject(res)
          }
        })
        .catch(res => {
          reject(res)
        })
    })
  },
  [TYPES.DO_GET_ACCOUNT_RECORD_LIST]({ commit }, userID) {
    return new Promise(function (resolve, reject) {
      api.DO_GET_ACCOUNT_RECORD_LIST(userID)
        .then(res => {
          if (res.data.ok) {
            commit(TYPES.ON_GET_ACCOUNT_RECORD_LIST, res.data.data)
            resolve(res)
          } else {
            reject(res)
          }
        })
        .catch(res => {
          reject(res)
        })
    })
  },
  [TYPES.DO_LOGIN]({ commit }, playload) {
    return new Promise(function (resolve, reject) {
      api.DO_LOGIN(playload)
        .then(res => {
          if (res.data.ok) {
            commit(TYPES.ON_LOGIN, res.data.data)
            resolve(res)
          } else {
            reject(res)
          }
        })
        .catch(res => {
          reject(res)
        })
    })
  }
}

export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/users.js